module.exports = __webpack_public_path__ + "static/media/giotto.3a579210.png";